import { ActivitiesInternalResource as e } from "./resources/ActivitiesInternalResource.js";
import { AgentConfigurationResource as t } from "./resources/agent-configuration/AgentConfigurationResource.js";
import { AgentGatewayConfiguration as n } from "./resources/AgentGatewayConfiguration.js";
import { AnnouncementsResource as r } from "./resources/AnnouncementsResource.js";
import { AnswerResource as i } from "./resources/answer/AnswerResource.js";
import { AutomationFreezesResource as a } from "./resources/AutomationFreezesResource.js";
import { BatchAnswerResource as o } from "./resources/batch-answer/BatchAnswerResource.js";
import { CaseAssistConfigsInternalResource as s } from "./resources/CaseAssistConfigstInternalResource.js";
import { CatalogsPrivateResource as c } from "./resources/CatalogsPrivateResource.js";
import { ChunkInspectorResource as l } from "./resources/chunk-inspector/ChunkInspectorResource.js";
import { CommerceResource as u } from "./resources/commerce/Commerce.js";
import { ConditionResource as d } from "./resources/ConditionResource.js";
import { ConversationInspectorResource as f } from "./resources/conversation-inspector/ConversationInspectorResource.js";
import { CrawlingModuleInternalResource as p } from "./resources/CrawlingModuleInternalResource.js";
import { CRGADashboardResource as m } from "./resources/crga-dashboard/CRGADashboardResource.js";
import { DataServiceResource as h } from "./resources/DataServiceResource.js";
import { DocumentIdentityResource as g } from "./resources/DocumentIdentityResource.js";
import { ExportServiceResource as _ } from "./resources/ExportServiceResource.js";
import { ExtensionInternalResource as v } from "./resources/ExtensionInternalResource.js";
import { BuiltInGroupsResource as y } from "./resources/groups/BuiltInGroupsResource.js";
import { HardwareMinimumsResource as b } from "./resources/HardwareMinimumsResource.js";
import { HostedPagesInternalResource as x } from "./resources/HostedPagesInternalResource.js";
import { InAppWidgetResource as S } from "./resources/InAppWidgetResource.js";
import { InsightPanelConfigsInternalResource as C } from "./resources/InsightPanelConfigsInternalResource.js";
import { IPXInterfaceExperimentalResource as w } from "./resources/IPXInterfaceResource.js";
import { LicenseInternalResource as T } from "./resources/LicenseInternalResource.js";
import { LogicalIndexesResource as E } from "./resources/LogicalIndexesResource.js";
import { MCPConfigurationsResource as D } from "./resources/MCPConfigurationsResource.js";
import { MCPPipelinesResource as O } from "./resources/MCPPipelinesResource.js";
import { ModelsInternalResource as k } from "./resources/ModelsInternalResource.js";
import { NextGenSearchPagesInternalResource as A } from "./resources/NextGenSearchPagesInternalResource.js";
import { NotificationEventResource as j } from "./resources/NotificationEventResource.js";
import { OrganizationCustomerKeysResource as M } from "./resources/OrganizationCustomerKeysResource.js";
import { OrganizationDefinitionResource as N } from "./resources/OrganizationDefinitionResource.js";
import { OrganizationHealthMonitoringResource as P } from "./resources/OrganizationHealthMonitoringResource.js";
import { OrganizationInternalResource as F } from "./resources/OrganizationInternalResource.js";
import { OrganizationMonitoringResource as I } from "./resources/OrganizationMonitoringResource.js";
import { OrganizationQuotasResource as L } from "./resources/OrganizationQuotasResource.js";
import { OrganizationSettingsResource as R } from "./resources/OrganizationSettingsResource.js";
import { PipelineInternalResource as z } from "./resources/PipelineInternalResource.js";
import { PipelineSettingsResource as B } from "./resources/PipelineSettingsResource.js";
import { PreviewResource as V } from "./resources/PreviewResource.js";
import { PrivateLicenseResource as H } from "./resources/PrivateLicenseResource.js";
import { PrivilegesResource as U } from "./resources/PrivilegesResource.js";
import { ProjectInternalResource as W } from "./resources/ProjectInternalResource.js";
import { ReportInternalResource as G } from "./resources/ReportInternalResource.js";
import { SalesforceSourceConfigurationInternalResource as K } from "./resources/SalesforceSourceConfigurationInternalResource.js";
import { SchemaServiceTemporaryResource as q } from "./resources/SchemaServiceTemporaryResource.js";
import { SearchDictionaryFieldsResource as J } from "./resources/SearchDictionaryFieldsResource.js";
import { SearchInterfacesInternalResource as Y } from "./resources/SearchInterfacesInternalResource.js";
import { SearchPagesInternalResource as X } from "./resources/SearchPagesInternalResource.js";
import { SecurityCacheInternalResource as Z } from "./resources/SecurityCacheInternalResource.js";
import { SourcesInternalResource as Q } from "./resources/SourcesInternalResource.js";
import { WebsitesInternalResource as $ } from "./resources/WebsitesInternalResource.js";
import { PlatformClient as ee } from "@coveo/platform-client";
//#region src/PrivatePlatformClient.ts
var te = [
	{
		key: "activitiesInternal",
		resource: e
	},
	{
		key: "agentConfiguration",
		resource: t
	},
	{
		key: "agentGatewayConfiguration",
		resource: n
	},
	{
		key: "announcements",
		resource: r
	},
	{
		key: "answer",
		resource: i
	},
	{
		key: "automationFreezes",
		resource: a
	},
	{
		key: "batchAnswer",
		resource: o
	},
	{
		key: "builtInGroups",
		resource: y
	},
	{
		key: "catalogsPrivate",
		resource: c
	},
	{
		key: "caseAssistConfigsInternal",
		resource: s
	},
	{
		key: "chunkInspector",
		resource: l
	},
	{
		key: "commerce",
		resource: u
	},
	{
		key: "conversationInspector",
		resource: f
	},
	{
		key: "condition",
		resource: d
	},
	{
		key: "crawlingModuleInternal",
		resource: p
	},
	{
		key: "crgaDashboard",
		resource: m
	},
	{
		key: "dataService",
		resource: h
	},
	{
		key: "documentIdentity",
		resource: g
	},
	{
		key: "exportService",
		resource: _
	},
	{
		key: "extensionInternal",
		resource: v
	},
	{
		key: "hardwareMinimums",
		resource: b
	},
	{
		key: "inAppWidget",
		resource: S
	},
	{
		key: "insightPanelConfigsInternal",
		resource: C
	},
	{
		key: "hostedPagesInternal",
		resource: x
	},
	{
		key: "ipxInterfaceExperimental",
		resource: w
	},
	{
		key: "licenseInternal",
		resource: T
	},
	{
		key: "logicalIndexes",
		resource: E
	},
	{
		key: "mcpConfigurations",
		resource: D
	},
	{
		key: "mcpPipelines",
		resource: O
	},
	{
		key: "modelsInternal",
		resource: k
	},
	{
		key: "nextGenSearchPagesInternal",
		resource: A
	},
	{
		key: "notificationEvent",
		resource: j
	},
	{
		key: "organizationInternal",
		resource: F
	},
	{
		key: "organizationCustomerKeys",
		resource: M
	},
	{
		key: "organizationDefinition",
		resource: N
	},
	{
		key: "organizationQuotas",
		resource: L
	},
	{
		key: "organizationHealthMonitoring",
		resource: P
	},
	{
		key: "organizationMonitoring",
		resource: I
	},
	{
		key: "organizationSettings",
		resource: R
	},
	{
		key: "pipelineInternal",
		resource: z
	},
	{
		key: "pipelineSettings",
		resource: B
	},
	{
		key: "privateLicense",
		resource: H
	},
	{
		key: "preview",
		resource: V
	},
	{
		key: "privileges",
		resource: U
	},
	{
		key: "projectInternal",
		resource: W
	},
	{
		key: "reportInternalResource",
		resource: G
	},
	{
		key: "salesforceSourceConfigurationInternal",
		resource: K
	},
	{
		key: "schemaServiceTemporary",
		resource: q
	},
	{
		key: "searchDictionaryFields",
		resource: J
	},
	{
		key: "searchInterfacesInternal",
		resource: Y
	},
	{
		key: "searchPagesInternal",
		resource: X
	},
	{
		key: "sourcesInternal",
		resource: Q
	},
	{
		key: "securityCacheInternal",
		resource: Z
	},
	{
		key: "websitesInternal",
		resource: $
	}
], ne = class extends ee {
	constructor(e) {
		super(e), te.forEach(({ key: e, resource: t }) => {
			this[e] = new t(this.API, this.ServerlessAPI);
		});
	}
};
//#endregion
export { ne as PrivatePlatformClient };

//# sourceMappingURL=PrivatePlatformClient.js.map